<template>
	<div class="tw-flex tw-items-center tw-gap-2">
		<AppBadge
            v-if="orderReturnDetailsStore.data && orderReturnDetailsStore.data.shipment_status"
			class="tw-w-fit"
			:label="$t(`orders.shipment-status.${orderReturnDetailsStore.data.shipment_status}`)"
			:variant="shipmentStatusColor[orderReturnDetailsStore.data.shipment_status]"
		/>
		<AppButton
			v-if="
				orderReturnDetailsStore.data &&
				orderReturnDetailsStore.data.shipment_status == 'Returned'
			"
			:label="$t('orders.refund-order')"
			@click="refundOrderDialogStore.openDialog(orderReturnDetailsStore.data)"
			:disabled="orderReturnDetailsStore.loading || orderReturnDetailsStore.acceptedCount === 0"
		/>
	</div>
</template>

<script setup>
import AppBadge from '@/v2/components/badge.vue';
import { useOrderReturnDetailsStore } from '../../../stores/order-return-details';
import { useRefundOrderDialogStore } from '../../../stores/refund-order-dialog';
import { shipmentStatusColor } from '../../../entities/order-return';

const refundOrderDialogStore = useRefundOrderDialogStore();
const orderReturnDetailsStore = useOrderReturnDetailsStore();
</script>

<style lang="scss" scoped></style>
